<div *ngIf="entry.entrytype == 'medication'">
    <div><fa-icon [icon]="['fas', 'file-medical']" class="action-fa-icon" size="lg" style="margin-right: 10px;"></fa-icon>{{ entry.getProperty('packagelabel') || entry.value }}</div>
    <div><app-prescription-posology [entry]="entry" class="prescription-posology"></app-prescription-posology></div>
    <mat-divider style="margin-top: 10px;margin-bottom: 10px;"></mat-divider>
    <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="grow">
            <mat-form-field class="field-medium">
                <mat-label>Boîte(s)</mat-label>
                <input matInput type="number" #box maxlength="5" [(ngModel)]="entry.packagenb">
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-medium">
                <mat-label>Par jour</mat-label>
                <input matInput type="number" #perday maxlength="5" [(ngModel)]="entry.perday">
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-medium">
                <mat-label>Tous les x jour(s)</mat-label>
                <input matInput type="number" #everydays maxlength="5" [(ngModel)]="entry.everydays">
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-medium">
                <mat-label>Nombre de jour(s)</mat-label>
                <input matInput type="number" #numberofdays maxlength="5" [(ngModel)]="entry.days">
            </mat-form-field>
        </div>
    </div>
    <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="grow">
            <mat-form-field class="field-small">
                <mat-label>Matin</mat-label>
                <input matInput type="number" #morning maxlength="5" [(ngModel)]="entry.poso2">
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-small">
                <mat-label>10h</mat-label>
                <input matInput type="number" #aftermorning maxlength="5" [(ngModel)]="entry.poso4">
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-small">
                <mat-label>Midi</mat-label>
                <input matInput type="number" #everydays maxlength="5" [(ngModel)]="entry.poso6">
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-small">
                <mat-label>16h</mat-label>
                <input matInput type="number" #everydays maxlength="5" [(ngModel)]="entry.poso8">
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-small">
                <mat-label>Soir</mat-label>
                <input matInput type="number" #everydays maxlength="5" [(ngModel)]="entry.poso10">
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-small">
                <mat-label>Coucher</mat-label>
                <input matInput type="number" #everydays maxlength="5" [(ngModel)]="entry.poso12">
            </mat-form-field>
        </div>
    </div>
    <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="grow">
            <mat-form-field class="field-medium">
                <mat-label>Début</mat-label>
                <input matInput [matDatepicker]="pickerstart" [formControl]="startdate" [(ngModel)]="entry.StartDate">
                <mat-datepicker-toggle matSuffix [for]="pickerstart"></mat-datepicker-toggle>
                <mat-datepicker #pickerstart></mat-datepicker>
            </mat-form-field>
        </div>
        <div fxFlex="grow">
            <mat-form-field class="field-medium">
                <mat-label>Fin</mat-label>
                <input matInput [matDatepicker]="pickerend" [formControl]="enddate" [(ngModel)]="entry.EndDate">
                <mat-datepicker-toggle matSuffix [for]="pickerend"></mat-datepicker-toggle>
                <mat-datepicker #pickerend></mat-datepicker>
            </mat-form-field>
        </div>
        <div fxFlex="grow" style="text-align: center;">
            <mat-slide-toggle style="padding-top: 19px;" [(ngModel)]="entry.Chronic">Chonique</mat-slide-toggle>
        </div>
    </div>
    <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="grow">
            <mat-form-field class="field-full-width">
                <mat-label>Commentaire</mat-label>
                <textarea matInput placeholder="" [(ngModel)]="entry.Comment" style="width:100%;height:4em;"></textarea>
            </mat-form-field>
        </div>
    </div>
</div>
<div *ngIf="entry.entrytype == 'treatment'">
    <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="grow">
            <mat-form-field class="field-full-width">
                <mat-label>Titre</mat-label>
                <input matInput type="text" [(ngModel)]="entry.value">
            </mat-form-field>
        </div>
    </div>
    <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="grow">
            <mat-form-field class="field-full-width">
                <mat-label>Commentaire</mat-label>
                <textarea matInput placeholder="" [(ngModel)]="entry.Comment" style="width:100%;height:4em;"></textarea>
            </mat-form-field>
        </div>
    </div>
</div>